<template>
  <div class="root">
    <header class="header"
      :class="{ 'dark-theme': isDarkTheme, 'isPrice': ['/price', '/pay-mobile'].includes($route.path) && !isWhiteHeaderBg, 'isMember': ['/member-mobile'].includes($route.path) }">
      <div class="container header-container">
        <div class="header-left">

          <img v-if="isMobile() && ['/login', '/reset-password', '/register-login'].includes($route.path)"
            class="bg-title" src="@/assets/bg_header_mobile.png" />

          <div class="logo">


            <el-icon class="arrow-left-icon" v-if="$route.path !== '/' && $route.path !== '/home'"
              @click="backMethod()">
              <ArrowLeft />
            </el-icon>

            <img v-if="$route.path === '/' || $route.path === '/home' || !isMobile()" src="@/assets/logo.png" alt="logo"
              class="logo-img" />


            <div v-if="$route.path != '/' && $route.path != '/home' && isMobile()" class="title-box">
              {{ $route.meta.title || '标题' }}
              <img class="img-aqua" src="@/assets/img_aqua.png" alt="" />
            </div>

            <img v-if="$route.path == '/' || $route.path == '/home'" src="@/assets/svg/icon_header_menu.svg"
              class="menu-icon" alt="menu" style="width: 24px;height: 24px;" @click="clickMenu" />

            <div class="option-right-btn" @click="router.push('/login')"
              v-if="!data && $route.path == '/home' && isMobile()"><span class="nav-item-text">登录/注册</span></div>
            <div class="option-right-btn" @click="toColorCardPage"
              v-else-if="data && $route.path == '/home' && isMobile() && isDarkTheme">
              快速制作
            </div>
            <img v-else-if="data && isMobile() && !isDarkTheme && ($route.path === '/' || $route.path === '/home')"
              class="option-create-img" src="@/assets/btn_create.png" @click="toColorCardPage" />
          </div>
          <nav class="nav-menu">
            <router-link to="/" class="nav-item" :class="{ 'active': $route.path === '/' }"><span
                class="nav-item-text">首页</span></router-link>
            <router-link v-if="userInfo?.userName" to="/price" class="nav-item" :class="{ 'active': $route.path === '/price' }"><span
                class="nav-item-text">价格</span></router-link>
            <!-- <a class="nav-item"><span class="nav-item-text">帮助中心</span></a> -->
            <a class="nav-item" @click="toWaperAblout"><span class="nav-item-text">关于我们</span></a>
          </nav>
        </div>
        <div class="header-right">
          <!-- <el-button type="primary" class="contact-btn" @click="qrcodeDialogVisible = true"> -->
          <div class="contact-btn" @click="qrcodeDialogVisible = true">
            <img src="@/assets/home_contact.png" alt="phone" />
            <p>联系客服</p>
          </div>
          <!-- </el-button> -->
         
          <!-- <div type="primary" class="register-btn" v-if="!data" @click="goToRegister">
            立即注册
          </div> -->

          <div class="userInfo" v-if="userInfo?.userName">

            <div class="go-btn" style="margin-right: 30px;" @click="goToWorkbench">快速制作</div>

            <div class="guide-btn" v-if="showGuideOverlay" @click="hideGuide">
              <img src="@/assets/bg_guide_bubble.png" alt="guide" />
              <p>进入电子色卡管理后台</p>
            </div>

            <el-dropdown @command="handleUserCommand" trigger="click">
              <img class="avatar"
                :src="data.avatar || 'https://unpkg.com/@vbenjs/static-source@0.1.7/source/avatar-v1.webp'" />
              <template #dropdown>
                <el-dropdown-menu class="custom-dropdown-menu">
                  <el-dropdown-item class="custom-info-item">
                    <div class="user-name">{{ userInfo?.nickName }}</div>
                    <div class="phone-number">{{ userInfo?.phonenumber }}</div>
                  </el-dropdown-item>
                  <el-dropdown-item command="person" class="custom-logout-item">
                    <img class="logout-icon" src="@/assets/个人中心.png" alt="logout" />
                    <span class="person-text">个人中心</span>
                    <icon class="arrow-right-icon" style="width: 16px;height: 16px;">
                      <ArrowRight />
                    </icon>
                  </el-dropdown-item>
                  <el-dropdown-item command="logout" class="custom-logout-item">
                    <img class="logout-icon" src="@/assets/退出.png" alt="logout" />
                    <span class="logout-text">退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <!-- <el-button type="primary" class="register-btn" @click="logout">
              退出登录
            </el-button> -->

          </div>
          <router-link to="/login" class="login-btn" v-else><span class="text">登录/注册</span></router-link>
        </div>

      </div>

    </header>
    <ContactCustomDialog :visible="qrcodeDialogVisible" :type="currentDialogType" @cancel="qrcodeDialogVisible = false">
    </ContactCustomDialog>

    <!-- 移动端菜单 -->
    <MobileMenu v-model="drawer" :user-data="data" @contact="qrcodeDialogVisible = true" @logout="logout" />

    <!-- 引导蒙层 -->
    <!-- <div v-if="showGuideOverlay" class="guide-overlay" @click="hideGuide"> </div>-->

  </div>
</template>

<script setup>
import { ref, onMounted,computed, watch,onBeforeUnmount  } from 'vue'
import ContactCustomDialog from '@/components/ContactCustomDialog.vue'
import MobileMenu from '@/components/MobileMenu.vue'
import { useRouter, useRoute } from 'vue-router'
import { ArrowLeft } from '@element-plus/icons-vue'
import { isMobile } from '@/utils/index';
import { getWxJumpUrl } from '@/api/user';

const props = defineProps({
  isDarkTheme: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object,
    default: undefined
  },
  isWhiteHeaderBg: {
    type: Boolean,
    default: false
  },
})

//二维码弹窗
const qrcodeDialogVisible = ref(false)
const drawer = ref(false)
const showGuideOverlay = ref(false)

const userInfo = ref()

const workbenchUrl = ref(import.meta.env.VITE_GLOB_BACK_URL)

/**
 * 检测当前是否运行在微信内置浏览器中
 */
function detectWeChatBrowser() {
  // 确保 navigator 对象存在（避免特殊运行环境报错）
  if (typeof navigator === 'undefined') {
    console.warn('当前环境无 navigator 对象，无法检测浏览器类型');
    return false;
  }

  // 使用 includes 替代 indexOf，语义更清晰（ES6 特性，现代浏览器均支持）
  const isWeChat = navigator.userAgent.includes('MicroMessenger') && !navigator.userAgent.includes('wxwork');

  // alert( navigator.userAgent);

  //若需支持 IE11 等不支持 includes的旧浏览器，可将 includes替换为 indexOf !== -1
  //const isWeChat = navigator.userAgent.indexOf('MicroMessenger') !== -1;

  // 三元表达式简化条件输出
  console.log(isWeChat ? '微信内置浏览器' : '外部浏览器');

  return isWeChat;
}

const toWaperAblout = () => {
  window.open('https://www.waper.com.cn/index.html#/about', '_blank')
}

const toColorCardPage = () => {

  let clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID || '';
  if (window.innerWidth < 768) {
    clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID_MOBILE || '';
  }
  const token = localStorage.getItem('access_token') || '';

  let isWeChat = detectWeChatBrowser()
  // if (isWeChat) {
  //   // 微信内置浏览器，跳转到微信跳转地址
  //   getWxJumpUrl().then(res => {
  //     if (res.code === 200) {
  //       localStorage.setItem('clientid', clientId);
  //       localStorage.setItem('access_token', token);
  //       // 存储跳转地址到本地存储
  //       localStorage.setItem('wxstate', res.data.state);
  //       window.location.href = res.data.authorizeUrl;
  //     }
  //   })
  // } else {
  //   const externalUrl = `${location.origin}/back/preview/index.html#/redirect?accessToken=${token}&clientId=${clientId}`;
  //   window.location.href = externalUrl;
  // }

  const externalUrl = `${location.origin}/back/preview/index.html#/redirect?accessToken=${token}&clientId=${clientId}`;
  window.location.href = externalUrl;

}

const logout = () => {
  localStorage.setItem('userInfo', '');
  localStorage.setItem('access_token', '');
  // window.location.href = '/login'
  router.push({
    path: '/login',
    query: {
      redirect: route.fullPath
    }
  })
}



const router = useRouter() // 添加这行
const route = useRoute()

// 最新的用户名
const userName = ref('')
// 添加这个方法
const goToRegister = () => {
  // router.push('/login?tab=register') redirect: route.fullPath
  router.push({
    path: '/login',
    query: {
      tab: 'register',
      redirect: route.fullPath
    }
  })
}

const clickMenu = () => {
  drawer.value = !drawer.value
}

const backMethod = () => {
  if (route.path == '/login' && route.query.from == 'mine') {
    router.push('/')
  } else {
    router.back()
  }
}

const handleUserCommand = (cmd) => {
  if (cmd === 'person') {
    window.open(workbenchUrl.value + '#/profile', '_blank')
  } else if (cmd === 'logout') {
    logout()
  }
}

// 进入工作台
const goToWorkbench = () => {
  hideGuide()
  window.open(workbenchUrl.value+'#/manage/cardList', '_blank', 'noopener')
}

// 从 localStorage 加载最新值
function loadUserName() {
  try {
    const data = JSON.parse(localStorage.getItem('userInfo') || '{}');
    userName.value = data.nickName || '';
    console.log('✅ 已加载:', userName.value);
  } catch {
    userName.value = '';
  }
}

// storage 事件触发时重新加载
function handleStorageChange(e) {
  if (e.key === 'userInfo') {
    console.log('storage 事件触发，重新加载');
    loadUserName(); // 👈 关键：重新读取
  }
}

// 隐藏引导蒙层
const hideGuide = () => {
  showGuideOverlay.value = false
  localStorage.setItem('workbench-guide-shown', true)
}

let intervalId = null

// 路由切换重复执行
watch(route, () => {
  userInfo.value = JSON.parse(localStorage.getItem('userInfo') || '{}')
}, { immediate: true })

onMounted(() => {
  showGuideOverlay.value = !localStorage.getItem('workbench-guide-shown')
 
  intervalId = setInterval(() => {
     userInfo.value = JSON.parse(localStorage.getItem('userInfo') || '{}')
  }, 1000)
 
})

onBeforeUnmount(() => {
  clearInterval(intervalId)
})

</script>

<style scoped lang="scss">
.root {
  position: relative;
}

.header {
  /* background-color: #0d1117; */
  /* color: black; */
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  /* backdrop-filter: blur(4.5px); */
  /* background-color: rgba(255, 255, 255, 0.94); */

  border-bottom: 1px solid rgba(222, 226, 230, 0.2);
  background-color: white;

  /* 默认浅色主题变量 */
  --nav-item-color: #75777B;
  --nav-item-hover-color: #333333;
  --logo-color: 1;
  --mobile-logo-color: 0;
  --border-color: #75777B;
}

/* 深色主题 */
.header.dark-theme {
  --nav-item-color: white;
  --nav-item-hover-color: white;
  --logo-color: 0;
  --mobile-logo-color: 1;
  background-color: transparent;
  --border-color: transparent;
}

.header.isPrice {
  background-color: transparent;
}

.header.isMember {
  background: #f7f0e3;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  margin-right: 114px;

  .logo-img {
    /* margin-top: 5px; */
    width: 146px;
    height: 37px;
    filter: invert(var(--logo-color));
  }


  .title-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;

    .img-aqua {
      margin-top: 3px;
      width: 60px;
      height: 5px;
    }
  }
}

.logo .menu-icon {
  display: none;
}




.logo-icon {
  color: #8a61ff;
  margin-right: 10px;
}

.logo span {
  /* font-size: 18px; */
  font-weight: bold;
}

.nav-menu {
  display: flex;
  gap: 72px;
  height: 69px;
}

.nav-item {
  color: var(--nav-item-color);
  text-decoration: none;
  font-size: 14px;
  padding: 5px 0;
  position: relative;
  font-weight: 500;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;

  &.active {
    /* color: #5A9CFF !important; */
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 50%;
    width: 0;
    height: 3px;
    background-color: var(--nav-item-color);
    transform: translateX(-50%);
  }

  &.active:after {
    width: 100%;
    left: 0;
    transform: translateX(0);
  }
}

.nav-item:hover {
  color: var(--nav-item-hover-color);
}

.nav-item:hover:after {
  width: 100%;
  left: 0;
  transform: translateX(0);
}

.nav-item-text {
  text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.1);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 30px;
}

.userInfo {
  /* background-color: red; */
  display: flex;
  align-items: center;
  position: relative;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  /* background-color: gainsboro; */
  margin-right: 20px;
  cursor: pointer;
  object-fit: cover;
}


:deep(.el-button) {
  border-radius: 8px;
}

.contact-btn {
  border-radius: 40px;
  color: var(--nav-item-color);
  /* background-color: #7148FF; */
  border: 1px solid var(--border-color);
  /* border-color: #7148FF; */
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  /* height: 36px; */
  line-height: 14px;
  padding: 12px 26px;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
    margin-right: 9px;
    margin-top: -1px;
  }

  p {
    height: 14px;
    line-height: 16px;
    margin-top: -1px;
    font-size: 14px;
    text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.1);
  }
}

.header:not(.dark-theme) .contact-btn img {
  filter: brightness(0) saturate(100%);
}

.contact-btn:hover {
  /* border-color: var(--nav-item-color);
  color: var(--nav-item-color);
  background-color: transparent; */
  /* box-shadow: 0 2px 8px rgba(43, 21, 117, 0.3); */
  opacity: 0.6;
}

.login-btn {
  color: var(--nav-item-color);
  text-decoration: none;
  font-size: 14px;
  line-height: 14px;
  padding: 9px 26px;
  /* height: 36px; */
  /* line-height: 36px; */
  border-radius: 18px;
  border: 1px solid var(--nav-item-color);

  .text {
    padding: 12px 0;
  }
}

.login-btn:hover {
  /* color: #8a61ff; */
  opacity: 0.8;
}

.go-btn {
  // height: 36px;
  line-height: 14px;
  padding: 12px 20px;
  border: 0px solid transparent;
  color: white;
  background-color: transparent;
  font-size: 14px;
  background: linear-gradient(229deg, #4E5AFF 0%, #724BF7 52%, #7D48FF 100%);
  border-radius: 8px;
  cursor: pointer;
  font-family: MiSans, MiSans;
}

.go-btn:hover {
  /* border-color: #8a61ff;
  color: var(--nav-item-color);
  background-color: #8a61ff; */

  /* background: transparent;
  border-color: var(--nav-item-color);
  color: var(--nav-item-color);
  background-color: transparent; */
  box-shadow: 0 2px 8px rgba(43, 21, 117, 0.3);
}

.guide-btn {
  position: absolute;
  left: -33px;
  top: 42px;
  z-index: 999;
  /* width: 100vw; */
  /* height: 100vh; */
  /* display: none; */
  /* background-color: red; */
  cursor: pointer;

  img {
    width: 164px;
    height: 34px;
    position: absolute;
  }

  p {
    position: absolute;
    width: 164px;
    height: 30px;
    line-height: 14px;
    margin-top: 4px;
    // background-color: red; 
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    font-family: MiSans, MiSans;
    font-weight: 500;
    display: flex;
    padding-bottom: 1px;
    justify-content: center;
    align-items: center;
  }
}

.guide-overlay {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  z-index: 99;
  cursor: pointer;
}

.register-btn {
  height: 36px;
  line-height: 36px;
  padding: 0 16px;
  border: 1px solid transparent;
  color: white;
  background-color: transparent;
  font-size: 14px;
  background: linear-gradient(229deg, #4E5AFF 0%, #724BF7 52%, #7D48FF 100%);
  border-radius: 6px;
  cursor: pointer;
}

.register-btn:hover {
  /* border-color: #8a61ff;
  color: var(--nav-item-color);
  background-color: #8a61ff; */

  /* background: transparent;
  border-color: var(--nav-item-color);
  color: var(--nav-item-color);
  background-color: transparent; */
  box-shadow: 0 2px 8px rgba(43, 21, 117, 0.3);
}

.arrow-left-icon {
  display: none;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .header {
    padding: 0;
    width: 100vw;
  }

  .container {
    margin: 0;
    padding: 0;
    height: 78px;
  }

  .header-left {
    /* background-color: red; */
    /* width: 100vw; */
    display: flex;
    justify-content: center;
    height: 78px;
    align-items: center;
    position: relative;


    .bg-title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 78px;
      height: 117px;
      z-index: -1;
      pointer-events: none;
    }
  }

  .header-right {
    display: none;
  }

  .logo {
    margin-right: 0;
    /* background-color: red; */
    width: 100vw;
    position: relative;
    display: flex;
    justify-content: center;


    .arrow-left-icon {
      display: flex;
      position: absolute;
      left: 12px;
      color: black;
      font-weight: bold;
      font-size: 24px;
    }


    .logo-img {
      width: 97px;
      height: 25px;
    }

    /* .menu-icon {
      width: 24px;
      height: 24px;
      display: block;
      position: absolute;
      right: 0;
      top: 0;
    } */

  }

  .logo .menu-icon {
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    /* background-color: red; */
    filter: invert(var(--mobile-logo-color));
  }

  .logo .option-right-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--nav-item-color);
    height: 31px;
    line-height: 30px;
    padding: 0px 12px;
    border: 1px solid var(--nav-item-hover-color);
    border-radius: 20px;
    font-size: 14px;
    text-align: center;

    /* border-image: linear-gradient(270deg, rgba(48, 119, 244, 1), rgba(167, 123, 232, 1)) 2 2; */
  }

  .logo .option-create-img {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 80px;
    height: 31px;
  }


  .nav-menu {
    display: none;
  }

}

/* 自定义退出登录按钮样式 */
:deep(.custom-dropdown-menu) {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  min-width: 182px;
}

:deep(.custom-logout-item) {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: #ef4444;
  font-weight: 500;
  transition: all 0.2s ease;
}

:deep(.custom-info-item) {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 10px 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

:deep(.custom-logout-item:hover) {
  background-color: #fef2f2;
  color: #dc2626;
}

:deep(.logout-icon) {
  width: 18px;

}

:deep(.logout-text) {
  color: #dc2626;
  font-size: 14px;
  margin-left: 10px;
}

:deep(.person-text) {
  color: #1D2129;
  font-size: 14px;
  margin-left: 5px;
}

.arrow-right-icon {
  color: #1D2129;
  font-size: 14px;
}

.user-name {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 16px;
  color: #1D2129;
  line-height: 14px;
  text-align: left;
  font-style: normal;
}

.phone-number {
  margin-top: 10px;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: #4E5969;
  line-height: 12px;
  text-align: left;
  font-style: normal;
}
</style>